import userInfo from "@/function/userInfo";
import { AddUserInAppPEAKCache, DeleteUserInAppPEAKCache, GetUserInAppPEAKFromCache } from "@/helper/cacheHelper";
import Enums from "../../../enums/enums";
import helper from "../../../helper/shareHelper";
import * as api from "../../../service/ApiSevice";
import store from "../../baseController";
export const actions = {
  async DoGetUserInAppSuggestion({ commit }) {
    const merchant = store.getters.GetMerchant;
    const user = store.getters.getUserModel;
    const onScreenFirstLoad = store.getters.GetOnScreenFirstLoad;
    const userSuggestion = {
      merchantId: merchant.merchantId,
      userId: user.userId,
      merchantCreateDateTime: merchant.createDateTime,
      joinMerchantDateTime: merchant.joinMerchantDateTime,
      inAppSuggestionTypes: [],
    };
    const isCheckOnScreenFirstLoad = !onScreenFirstLoad ? helper.CheckInAppScreenWidth() : true;
    commit("MutationSetUserInAppSuggestionLoadingStatus", Enums.LoadingStatusType.Loading);

    const userInAppPEAKCache = await GetUserInAppPEAKFromCache(userInfo.MerchantId());

    if (userInAppPEAKCache) {
      store.dispatch("DoSetUserInAppSuggestion", {
        userInAppSuggestion: userInAppPEAKCache,
        isCheckOnScreenFirstLoad: isCheckOnScreenFirstLoad,
      });
      commit("MutationSetUserInAppSuggestionLoadingStatus", Enums.LoadingStatusType.Success);
    } else {
      api.UserService.DoGetUserInAppPEAK(userSuggestion).then(async (res) => {
        if (res.responseCode.IsSuccess()) {
          await AddUserInAppPEAKCache(userInfo.MerchantId(), res.userInAppSuggestion);
          store.dispatch("DoSetUserInAppSuggestion", {
            userInAppSuggestion: res.userInAppSuggestion,
            isCheckOnScreenFirstLoad: isCheckOnScreenFirstLoad,
          });
          commit("MutationSetUserInAppSuggestionLoadingStatus", Enums.LoadingStatusType.Success);
        } else {
          commit("MutationSetUserInAppSuggestionLoadingStatus", Enums.LoadingStatusType.Failed);
        }
      });
    }
  },
  DoSetUserInAppSuggestion({ commit }, { userInAppSuggestion, isCheckOnScreenFirstLoad }) {
    commit(
      "MutationSetShouldShowInAppManualGuide",
      helper.CheckShouldShowInAppManualGuide(userInAppSuggestion) && isCheckOnScreenFirstLoad
    );

    if (helper.CheckInAppTutorial(userInAppSuggestion)) {
      commit("MutationSetInAppTutorial", true && isCheckOnScreenFirstLoad);
    } else if (helper.CheckInAppManualGuide(userInAppSuggestion)) {
      commit("MutationSetInAppManualGuide", true && isCheckOnScreenFirstLoad);
    }

    commit("MutationGetUserInAppSuggestion", userInAppSuggestion);
    commit("MutationSetOnScreenFirstLoad", true);
    commit("MutationSetInAppPeakExpSettings", helper.CheckInAppPeakExpSettings(userInAppSuggestion));
  },
  DoShowInAppTutorial({ commit }) {
    commit("MutationSetInAppTutorial", true);
    commit("MutationSetInAppPeakExpSettings", false);
  },
  DoCheckCloseInAppTutorial() {
    if (helper.CheckInAppTutorial(store.getters.GetUserInAppSuggestion)) {
      const merchant = store.getters.GetMerchant;
      const user = store.getters.getUserModel;
      const userSuggestion = {
        merchantId: merchant.merchantId,
        userId: user.userId,
        inAppType: Enums.inAppSuggestion.inAppTutorial,
      };
      api.UserService.DoUpdateUserInAppPEAK(userSuggestion)
        .then(async (res) => {
          if (res.responseCode.IsSuccess()) {
            await DeleteUserInAppPEAKCache(userInfo.MerchantId());
            store.dispatch("DoGetUserInAppSuggestion");
          }
        })
        .catch((error) => error);
    }
  },
  DoCloseInAppTutorial({ commit }) {
    commit("MutationSetInAppTutorial", false);
    store.dispatch("DoCheckCloseInAppTutorial");
  },
  DoShowInAppManualGuide({ commit }, status) {
    commit("MutationSetInAppManualGuide", status);
  },
  DoCloseInAppManualGuide({ commit, state }) {
    commit("MutationSetInAppManualGuide", false);
    if (helper.CheckInAppManualGuide(store.getters.GetUserInAppSuggestion)) {
      const merchant = store.getters.GetMerchant;
      const user = store.getters.getUserModel;
      const userSuggestion = {
        merchantId: merchant.merchantId,
        userId: user.userId,
        inAppType: Enums.inAppSuggestion.inAppManualGuide,
      };
      api.UserService.DoUpdateUserInAppPEAK(userSuggestion)
        .then(async (res) => {
          if (res.responseCode.IsSuccess()) {
            await DeleteUserInAppPEAKCache(userInfo.MerchantId());
            store.dispatch("DoGetUserInAppSuggestion");
          }
        })
        .catch((error) => error);
    }
  },
  DoShowInAppTourDocumentTour({ commit }, userInAppDocumentTour) {
    commit("MutationSetInAppTourDocumentTour", userInAppDocumentTour);
  },
  DoCloseInAppTourDocumentTour({ commit }) {
    commit("MutationSetInAppTourDocumentTour", { show: false, step: Enums.DocumentTour.None });
    store.dispatch("DoCheckCloseInAppTutorial");
  },
  DoCloseInAppPeakExpSettings({ commit }) {
    commit("MutationSetInAppPeakExpSettings", false);
    if (helper.CheckInAppPeakExpSettings(store.getters.GetUserInAppSuggestion)) {
      const merchant = store.getters.GetMerchant;
      const user = store.getters.getUserModel;
      const userSuggestion = {
        merchantId: merchant.merchantId,
        userId: user.userId,
        inAppType: Enums.inAppSuggestion.inAppPeakExpSettings,
      };
      api.UserService.DoUpdateUserInAppPEAK(userSuggestion).then(async (res) => {
        await DeleteUserInAppPEAKCache(userInfo.MerchantId());
      });
    }
  },
};
